var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97921 14.646C7.86788 14.646 7.76021 14.625 7.65621 14.583C7.55221 14.5417 7.45155 14.4723 7.35421 14.375L3.83321 10.854C3.66655 10.6873 3.58688 10.4757 3.59421 10.219C3.60088 9.96167 3.68755 9.74967 3.85421 9.583C4.02088 9.41634 4.22921 9.333 4.47921 9.333C4.72921 9.333 4.93755 9.41634 5.10421 9.583L8.02121 12.5L14.9172 5.604C15.0839 5.43734 15.2885 5.354 15.5312 5.354C15.7745 5.354 15.9795 5.43734 16.1462 5.604C16.3129 5.77067 16.3962 5.97567 16.3962 6.219C16.3962 6.46167 16.3129 6.66634 16.1462 6.833L8.60421 14.375C8.50688 14.4723 8.40621 14.5417 8.30221 14.583C8.19821 14.625 8.09055 14.646 7.97921 14.646Z",
    fill: "#173F4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6f36dfa33265c72e8567514f250bdfa0.svg";
export { ForwardRef as ReactComponent };